"use client";

import styled from "styled-components";

interface PaginationItemProps {
  $active?: boolean;
  $disabled?: boolean;
}

export const Pagination = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
  width: 100%;
`;

export const PaginationItem = styled.li<PaginationItemProps>`
  border: 1px solid var(--border);
  border-radius: 8px;
  min-width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  color: var(--textLight);
  background: var(--background);
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
  user-select: none;

  svg {
    width: 18px;
    height: 18px;
  }

  ${({ $disabled }) =>
    $disabled &&
    `
    opacity: 0.5;
    cursor: default;
    
    &:hover {
      background: var(--background);
      color: var(--textLight);
      border-color: var(--border);
      transform: none;
      box-shadow: none;
    }
  `}

  ${({ $disabled }) =>
    !$disabled &&
    `
    &:hover {
      background: var(--primarySystem100);
      color: #fff;
      border-color: var(--primarySystem100);
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    &:active {
      transform: translateY(0);
    }
  `}

  ${({ $active }) =>
    $active &&
    `
      background: var(--primarySystem100);
      color: #fff;
      border-color: var(--primarySystem100);
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
      font-weight: 600;
      
      &:hover {
        background: var(--primarySystem400);
        border-color: var(--primarySystem400);
      }
  `}
`;
